import { render } from "./SongPage.vue?vue&type=template&id=344207ba"
import script from "./SongPage.vue?vue&type=script&lang=ts"
export * from "./SongPage.vue?vue&type=script&lang=ts"

import "./SongPage.vue?vue&type=style&index=0&id=344207ba&lang=css"
script.render = render

export default script